<template>
    <div class="container pt-3">
        <img :src="logo" height="50" class="mt-5">
        <div class="gv-container-header d-flex flex-column align-items-center pt-5 justify-content-center text-center">
            <h1 class="display-1 text-muted"><strong>404</strong></h1>
            <h2 class="title"><strong>La pagina no fue encontrada</strong></h2>
            <p class="text-muted">La página o el recurso al que intentabas acceder no esta<br> disponible por alguna razón.</p>
            <router-link :to="{ name: 'Dashboard' }" class="btn btn-h btn-dark">Inicio</router-link>
        </div>
    </div>
</template>
<script>
import logo from '@/assets/img/logo.png'
export default {
    data(){
        return {
            logo
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/P404.vue